import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// location-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearAssign(store) {
    store.commit('clearAssign')
  },
  updateSelectedAssignList(store, payload) {
    store.commit('updateSelectedAssignList', payload)
  },
  clearSelectedAssignList(store) {
    store.commit('clearSelectedAssignList')
  },
  async addAssign(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        name: store.state.addAssign['name'],
        type: Number(store.state.addAssign['type'])
      }
    }
    await Vue.http.post(URL + '/v2/admin/assign/regist', data, config)
  },
  async setAssigns(store, payload) {
    store.state.assigns = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/assign/list',
      data,
      config
    )
    // 成功
    store.commit('setAssigns', response)
  },
  async updateAssign(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        id: store.state.updateAssign['id'],
        name: store.state.updateAssign['name'],
        type: Number(store.state.updateAssign['type'])
      }
    }
    await Vue.http.post(URL + '/v2/admin/assign/update', data, config)
  },
  async deleteAssigns(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        ids: payload
      }
    }
    await Vue.http.post(URL + '/v2/admin/assign/delete', data, config)
  },
  async setDetailAssign(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        id: payload.id
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/assign/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/assignModules/actions.js